import axios from 'axios';
import { logout } from './auth';
import { translateApiMessage } from '../i18n/apiMessages';

// Production is hard-coded on purpose: on 13 Aug an env-based host sent
// production traffic to the bare apex (commit 82a2139). REACT_APP_API_BASE_OVERRIDE
// is set by NO committed env file — only inline by the staging deploy workflow
// (which checks the bundle for the production host) or in your own
// .env.development.local for local work, so this file never needs editing.

export const API_BASE = process.env.REACT_APP_API_BASE_OVERRIDE || "https://app.soroby.com/api/v1"
// export const API_BASE = process.env.REACT_APP_API_BASE_OVERRIDE || "http://localhost:3200/api/v1"

axios.defaults.baseURL = API_BASE

// The API writes `message` in English; every toast and error line reads it
// from the response, so translate it once here into the UI language.
const localizeMessage = (response) => {
    if (response?.data && typeof response.data.message === 'string')
        response.data.message = translateApiMessage(response.data.message)
    return response
}

// A company suspended (or out of trial) mid-session makes every request answer
// with this. Sign out once and let the login page explain, instead of one
// error toast per request. Checked on the API's English text, before it is
// translated; the body carries code 403 whatever the HTTP status.
const COMPANY_SUSPENDED = 'Company access is suspended. Please contact support.'
const signOutIfCompanySuspended = (response) => {
    const data = response?.data
    if (data && data.code === 403 && data.message === COMPANY_SUSPENDED) {
        logout()
        if (window.location.pathname.indexOf('/login') !== 0)
            window.location.assign('/login?suspended=1')
    }
}

axios.interceptors.response.use(
    response => {
        signOutIfCompanySuspended(response)
        return localizeMessage(response)
    },
    error => {
        signOutIfCompanySuspended(error.response)
        localizeMessage(error.response)

        const expectedError =
            error.response &&
            error.response.status >= 400 &&
            error.response.status <= 500

        if(error.response.status === 401) {
            logout()
            
            if (window.location.pathname.indexOf('/login') !== 0)
                window.location.assign("/login")
        }

        if (expectedError) return Promise.resolve(error.response)

        return Promise.reject(error.response)
    }
)

const CancelToken = axios.CancelToken;
export const cancelTokenSource = CancelToken.source();

const http = {
    get: axios.get,
    put: axios.put,
    post: axios.post,
    delete: axios.delete,
    patch: axios.patch
    //TODO: setJWT
}

export default http;
